import { IconsProps } from '@/types/shared'

const NewFolderIcons: React.FC<IconsProps> = (props) => {
    return (
        <div
            {...props}
            className={`flex items-center justify-center w-full h-full`}
        >
            <svg
                viewBox="0 0 20 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.875 11.7498H13.75V9.87476H15.625V7.99976H13.75V6.12476H11.875V7.99976H9.99997V9.87476H11.875V11.7498ZM2.49997 15.4998C1.98434 15.4998 1.54294 15.3162 1.17575 14.949C0.808563 14.5818 0.624969 14.1404 0.624969 13.6248V2.37476C0.624969 1.85913 0.808563 1.41772 1.17575 1.05054C1.54294 0.68335 1.98434 0.499756 2.49997 0.499756H8.12497L9.99997 2.37476H17.5C18.0156 2.37476 18.457 2.55835 18.8242 2.92554C19.1914 3.29272 19.375 3.73413 19.375 4.24976V13.6248C19.375 14.1404 19.1914 14.5818 18.8242 14.949C18.457 15.3162 18.0156 15.4998 17.5 15.4998H2.49997ZM2.49997 13.6248H17.5V4.24976H9.22653L7.35153 2.37476H2.49997V13.6248Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default NewFolderIcons
